import { Directive, inject, TemplateRef, ViewContainerRef } from '@angular/core'

import { Account } from '@account/models'

@Directive({ selector: '[sbBen]' })
export class IfBenefactorDirective {
  private account = inject(Account)
  private templateRef = inject<TemplateRef<any>>(TemplateRef)
  private viewContainerRef = inject(ViewContainerRef)

  constructor() {
    if (this.account.benefactor) {
      this.viewContainerRef.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainerRef.clear()
    }
  }
}
